exports = module.exports = require("./../node_modules/.npminstall/css-loader/0.21.0/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fade-transition {\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n}\n.fade-enter,\n.fade-leave {\n  height: 0;\n  opacity: 0;\n}\n.alert.top {\n  position: fixed;\n  top: 30px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  z-index: 1050;\n}\n.alert.top-right {\n  position: fixed;\n  top: 30px;\n  right: 50px;\n  z-index: 1050;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/css-loader/0.21.0/css-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/style-rewriter.js?id=_v-4a9b52ac&file=Alert.vue!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=style&index=0!./src/Alert.vue
// module id = 194
// module chunks = 0